import { CSSObject } from "@emotion/react";

export const searchBoxFilterWrapperCss: CSSObject = {
  display: "flex",
  alignItems: "center",
  gap: 16,
  width: "100%",
  maxWidth: "450px",
};

export const filterSearchBoxCss = (showError = false): CSSObject => ({
  marginBottom: showError ? "2px" : "18px",
});
